/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import {
    hideOverlayDialog,
    onKeyDownOverlayDialog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../../overlaydialog/overlaydialog.reducers';
import { showGuideScreen, showMainSettingsScreen } from '../../screens/screens.reducers';
import {
    onKeyOkAccountsOverlay,
    onMouseClickAccountsOverlay,
} from '../accountsoverlays/accountsoverlays.reducers';
import { setSelectedAccountOption } from './account.actions';
import {
    onKeyDownAccountOperations,
    onKeyOkAccountOperations,
    onKeyUpAccountOperations,
    onMouseClickAccountOperations,
    onMouseOutAccountOperations,
    onMouseOverAccountOperations,
} from './account.reducers';

export const onKeyBackAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(setSelectedAccountOption());
            dispatch(showMainSettingsScreen());
            break;
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(hideOverlayDialog());
            break;

        default:
    }
};

export const onKeyDownAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onKeyDownAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
            dispatch(onKeyDownOverlayDialog());
            break;

        default:
    }
};

export const onKeyGuideAccount = () => (dispatch: Function, getState: Function) => {
    const {
        overlayDialog: { isOverlayDialogActive },
    } = getState();
    if (isOverlayDialogActive) dispatch(hideOverlayDialog());
    dispatch(setSelectedAccountOption());
    dispatch(showGuideScreen());
};

export const onKeyOkAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onKeyOkAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onKeyOkAccountsOverlay());
            break;

        default:
    }
};

export const onKeyUpAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onKeyUpAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
            dispatch(onKeyUpOverlayDialog());
            break;

        default:
    }
};

export const onMouseClickAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onMouseClickAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
            dispatch(onMouseClickAccountsOverlay());
            break;

        default:
    }
};

export const onMouseOutAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onMouseOutAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOutOverlayDialogOperations());
            break;

        default:
    }
};

export const onMouseOverAccount = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_ACCOUNT_TASKS:
            dispatch(onMouseOverAccountOperations());
            break;
        case ScreenTaskControllerTypes.SETTINGS_RESET_APP_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_OVERLAY_TASKS:
        case ScreenTaskControllerTypes.SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS:
            dispatch(onMouseOverOverlayDialogOperations());
            break;

        default:
    }
};
